import SectionHeader from "../../components/commonUi/SectionHeader";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import ProjectTable from "./ProjectTable";
import { BsSearch } from "react-icons/bs";
import { GoPlus } from "react-icons/go";
import React, { useEffect, useState } from "react";
import apiClient from "../../service/Axios";
import NewProjectCreateModal from "../../components/Modals/NewProjectCreateModal";

const ProjectDetails = () => {
  const [projectData, setProjectData] = useState();
  const [visible, setVisible] = useState(false);
  const [loading, setLoding] = useState(false);
  const data = [
    {
      label: "All",
      value: "dashboard",
      no: projectData?.length,
      desc: (
        <ProjectTable
          loading={loading}
          projectData={projectData}
          setProjectData={setProjectData}
        />
      ),
    },
    {
      label: "Active",
      value: "profile",
      no: "0",
      desc: (
        <ProjectTable
          loading={loading}
          projectData={projectData}
          setProjectData={setProjectData}
        />
      ),
    },
    {
      label: "Archived",
      value: "settings",
      no: "0",
      desc: (
        <ProjectTable
          loading={loading}
          projectData={projectData}
          setProjectData={setProjectData}
        />
      ),
    },
  ];

  const projectdetailsListFunc = () => {
    setLoding(true);
    apiClient.get(`${process.env.REACT_APP_API}/project/list`).then((res) => {
      // reloadData();
      setProjectData(res.data);
      console.log("getprojectdata", res?.data);
      // setValue("");
      setLoding(false);
    });
  };
  useEffect(() => {
    projectdetailsListFunc();
  }, []);

  return (
    <div className="px-7">
      <div className="flex justify-between items-center">
        <SectionHeader
          title={"Projects Details"}
          objective={"Create manage and share your projects."}
        />
        <div className="flex justify-center items-center gap-8 mt-4">
          <div className="relative">
            <BsSearch className="absolute top-2.5 left-3 text-gray-500" />
            <input
              type="name"
              id="search"
              placeholder="Search"
              name="search"
              className="pl-10 border border-gray-400 w-full rounded-[5px] h-9"
            />
          </div>

          <button
            className="hover:bg-[#161B22] bg-[#161b22d1] text-white font-normal py-2 px-4 rounded-md inline-flex items-center"
            onClick={() => setVisible(true)}>
            <GoPlus className="font-bold text-xl" />
            <span>New Project</span>
          </button>
        </div>
      </div>
      <div className="mt-16">
        <Tabs value="dashboard">
          <div className="flex justify-between items-center">
            <TabsHeader>
              {data.map(({ label, value, no }) => (
                <Tab key={value} value={value}>
                  <div className="flex items-center gap-2">
                    {label}
                    <div className="avatar placeholder">
                      <div className="border-[1px] border-gray-400 text-neutral-content rounded-full w-5">
                        <span className="text-xs text-gray-700">{no}</span>
                      </div>
                    </div>
                  </div>
                </Tab>
              ))}
            </TabsHeader>
            <div className="flex justify-center item-center gap-3">
              <div className="flex justify-normal items-center gap-1 border bg-white border-gray-500 rounded-md px-3 py-1.5">
                <p className="text-[15px]">Triggered by: </p>
                <select className="font-normal text-[15px] bg-white">
                  <option selected>All</option>
                  <option>English</option>
                  <option>Japanese</option>
                  <option>Italian</option>
                </select>
              </div>
              <div className="flex justify-normal items-center gap-1 border bg-white border-gray-500 rounded-md px-3 py-1.5">
                <p className="text-[15px]">Tag: </p>
                <select className="font-normal text-[15px] bg-white">
                  <option selected>Project Tag</option>
                  <option>English</option>
                  <option>Japanese</option>
                  <option>Italian</option>
                </select>
              </div>
              <div className="flex justify-normal items-center gap-1 border bg-white border-gray-500 rounded-md px-3 py-1.5">
                <p className="text-[15px]">Sort by: </p>
                <select className="font-normal text-[15px] bg-white">
                  <option selected>Sent Email</option>
                  <option>English</option>
                  <option>Japanese</option>
                  <option>Italian</option>
                </select>
              </div>
              <div className="flex justify-normal items-center gap-1 border bg-white border-gray-500 rounded-md px-3 py-1.5">
                <p className="text-[15px]">Status: </p>
                <select className="font-normal text-[15px] bg-white">
                  <option selected>Active</option>
                  <option>English</option>
                  <option>Japanese</option>
                  <option>Italian</option>
                </select>
              </div>
            </div>
          </div>
          <TabsBody className="mt-3">
            {data.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                {desc}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>

      {/* project create modal */}
      <NewProjectCreateModal
        visible={visible}
        setVisible={setVisible}
        projectdetailsListFunc={projectdetailsListFunc}
      />
    </div>
  );
};

export default ProjectDetails;
